import { render, staticRenderFns } from "./add-update-resource.vue?vue&type=template&id=1697ebca&scoped=true&"
import script from "./add-update-resource.vue?vue&type=script&lang=js&"
export * from "./add-update-resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1697ebca",
  null
  
)

export default component.exports